// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - Start
import { memo } from "react";
import { Row, Col, Container } from "react-bootstrap";
import AnnualReport from "./AnnualReport";
import HealthScore from "./HealthScore";
import PeerComparison from "./PeerComparison";
import TrendAnalysis from "./TrendAnalysis";
import ShareHolding from "./ShareHolding";
import FundamentalRatios from "./FundamentalRatios";
const Fundamental = ({ handleMarketOverviewExpandOnclick, expandScripOverviewModel, isVertical = true }) => {

  return (
    <>
      <Container fluid className='p-0'>
        <Row className={`g-0 ${isVertical ? 'mt-5' : ''}`}>
          {isVertical ?
            <Col md={12} className='ps-3'>
              <PeerComparison handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} expandScripOverviewModel={expandScripOverviewModel} />
            </Col>
            : null}
        </Row>
        <Row className={`g-0 ${isVertical ? 'mt-5' : ''}`}>
          <Col md={isVertical ? 6 : 12} className={isVertical ? 'pe-3' : ''}>
              <HealthScore isVertical={isVertical} />
          </Col>
          <Col md={isVertical ? 6 : 12}>
            <FundamentalRatios isVertical={isVertical} />
          </Col>
        </Row>
        {isVertical ?
          <>
            <Row className='g-0 mt-5'>
              <Col md={6} className='pe-3'>
                <TrendAnalysis expandScripOverviewModel={expandScripOverviewModel} />
              </Col>
              <Col md={6} className='ps-3'>
                <ShareHolding  expandScripOverviewModel={expandScripOverviewModel}/>
              </Col>
            </Row>

            <Row className='g-0 mt-5'>
              <Col md={12}>
                <AnnualReport handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} />
              </Col>
            </Row>
          </>
          : null}
      </Container>
    </>
  );
};

export default memo(Fundamental);
// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - End